<template>
  <div class="form-login">
    <v-scroll-x-reverse-transition hide-on-leave>
      <two-factor-auth @snackbar="$emit('snackbar', $event)" v-if="show2Factor" />
    </v-scroll-x-reverse-transition>
    <v-scroll-x-transition hide-on-leave>
      <user-auth v-if="!show2Factor" @snackbar="$emit('snackbar', $event)" />
    </v-scroll-x-transition>
  </div>
</template>
<script lang="ts">
import TwoFactorAuth from "./forms/TwoFactorAuth.vue";
import UserAuth from "./forms/UserAuth.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {
    "two-factor-auth": TwoFactorAuth,
    "user-auth": UserAuth,
  },
})
export default class Form extends Vue {
  email = "";
  password = "";
  show2Factor = false;

  @Getter("authToken", { namespace: "loginState" })
  authToken!: string;

  @Watch("authToken")
  onTokenChange(): void {
    this.show2Factor = this.authToken && localStorage.getItem("2fa") != "false" ? true : false;
  }
}
</script>
<style lang="scss" scoped>
.form-login {
  overflow: hidden;
  background-color: #fff;
  max-height: 400px;
  @media (max-width: 960px) {
    max-height: unset;
  }
}
</style>
